"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingArea = exports.Cursor = exports.DrawingPanel = exports.DrawingIcon = exports.HyperlinkModal = exports.TextModal = exports.TaskModal = exports.TileLayer = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
var createjs = require("@caddigital/easeljs/lib/easeljs");
var L = require("leaflet");
var React = require("react");
var recompose = require("recompose");
var classNames = require("classnames");
var QuadTree_1 = require("./QuadTree");
var Text_1 = require("./Text");
var Path_1 = require("./Path");
var Rectangle_1 = require("./Rectangle");
var Cloud_1 = require("./Cloud");
var Circle_1 = require("./Circle");
var define = require("./define");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
require("leaflet/dist/leaflet.css");
require("./styles.scss");
/** super fast abs B====D */
var abs = function (x) { return (x < 0 ? -x : x); };
/** convert latlng to point */
var latlngToPoint = function (map, coords, pointCoordinate, zoom) {
    var p = map.project(pointCoordinate, zoom);
    var x = Math.round(p.x - coords.x);
    var y = Math.round(p.y - coords.y);
    // coords to tile space
    return new L.Point(x, y);
};
/** convert hex format to rgb(a) */
var rgb2hex = function (rgb) {
    var r = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return r && r.length === 4
        ? '#' +
            ('0' + parseInt(r[1], 10).toString(16)).slice(-2) +
            ('0' + parseInt(r[2], 10).toString(16)).slice(-2) +
            ('0' + parseInt(r[3], 10).toString(16)).slice(-2)
        : '';
};
var CanvasLayer = /** @class */ (function (_super) {
    __extends(CanvasLayer, _super);
    function CanvasLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.includes = [L.Mixin.Events, L.Mixin.TileLoader];
        _this.options = {
            tileLoader: false
        };
        return _this;
    }
    CanvasLayer.prototype.initialize = function (options) {
        this.options = options || {};
        this._color = define.DEFAULT_COLOR;
        this._lineWidth = define.LINE_WIDTH;
        this._animating = false;
        this._zooming = false;
        this._dragging = false;
        this._tool = null;
        this._drawingTool = null;
        this._dragBuffer = [];
        /** Create display canvas */
        this._canvas = this._createCanvas();
        this._ctx = this._canvas.getContext('2d');
        /** Create display canvas for quad tree */
        this._quadCanvas = this._createCanvas();
        /** Create display canvas for dummy rendering real-time stuff */
        this._drawCanvas = this._createCanvas();
        /** Create backbuffer canvas */
        this._backCanvas = this._createCanvas();
        /** create a new stage by getting reference to the canvas */
        this._quadStage = new createjs.Stage(this._quadCanvas);
        this._stage = new createjs.Stage(this._canvas);
        this._drawStage = new createjs.Stage(this._drawCanvas);
        this._shape = new createjs.Shape();
        this._drawShape = new createjs.Shape();
        this._backCanvas.style.display = 'none';
        this._ctx.lineJoin = 'round';
        this._fps = new createjs.Text();
        this._fps.x = 50;
        this._fps.y = 15;
        // this._stage.addChild(this._fps)
        this._quadStage.addChild(this._shape);
        this._drawStage.addChild(this._drawShape);
        // init nodes
        this._nodes = [];
        this._selectedNodes = [];
        this.tick = this.redraw.bind(this);
        createjs.Ticker.setFPS(60);
        createjs.Ticker.on('tick', this.tick.bind(this));
    };
    CanvasLayer.prototype.getCanvas = function () {
        return this._canvas;
    };
    CanvasLayer.prototype.getContext = function () {
        return this._ctx;
    };
    CanvasLayer.prototype.setTool = function (tool) {
        this._tool = tool;
    };
    CanvasLayer.prototype.setDrawingTool = function (drawingTool) {
        this._drawingTool = drawingTool;
    };
    CanvasLayer.prototype.setNodes = function (nodes) {
        this._nodes = nodes;
    };
    CanvasLayer.prototype.getNodes = function () {
        return this._nodes;
    };
    CanvasLayer.prototype.setColor = function (color) {
        this._color = color;
    };
    CanvasLayer.prototype.getColor = function () {
        return this._color;
    };
    CanvasLayer.prototype.addTo = function (map) {
        map.addLayer(this);
        return this;
    };
    CanvasLayer.prototype.insert = function (node) {
        this._stage.addChild(node);
        this._nodes.push(node);
        this._tree.insert(node);
        this._update();
        // cache node into vram
        node._draw(this._ctx);
        this.updateTree();
        // blit cached image
        this.redraw();
    };
    CanvasLayer.prototype.clear = function () {
        this._nodes = [];
        for (var i = 0; i < this._stage.children; i++) {
            this._stage[i].removeChildAt(i);
        }
        this._stage = new createjs.Stage(this._canvas);
        this._stage.clear();
        this.updateTree();
        this._update();
        this.redraw();
    };
    CanvasLayer.prototype.onAdd = function (map) {
        var _this = this;
        this._map = map;
        var tilePane = this._map._panes.tilePane;
        var container = L.DomUtil.create('div', 'canvas-layer');
        container.appendChild(this._canvas);
        container.appendChild(this._quadCanvas);
        container.appendChild(this._drawCanvas);
        tilePane.appendChild(container);
        this._container = container;
        // Listen to predrag event set container position (0, 0) coordinate
        if (map.dragging.enabled()) {
            ;
            map.dragging._draggable.on('predrag', function (e) {
                var d = map.dragging._draggable;
                L.DomUtil.setPosition(_this._canvas, new L.Point(-d._newPos.x, -d._newPos.y));
                L.DomUtil.setPosition(_this._quadCanvas, new L.Point(-d._newPos.x, -d._newPos.y));
                L.DomUtil.setPosition(_this._drawCanvas, new L.Point(-d._newPos.x, -d._newPos.y));
            }, this);
        }
        map.on({ viewreset: this._reset }, this);
        map.on('move', this._reposition, this);
        map.on('click', this._pick, this);
        map.on('mousedown', this._startDrag, this);
        map.on('mouseup', this._endDrag, this);
        map.on('mousemove', this._mouseMove, this);
        map.on('resize', this._resize, this);
        map.on({
            zoomstart: this._zoomStart,
            zoom: this._zoom,
            zoomend: this._zoomEnd
        }, this);
        if (this.options.tileLoader) {
            this._initTileLoader();
        }
        ;
        map._canvas = this._canvas;
        map._backCanvas = this._backCanvas;
        this._reset();
        return this;
    };
    // callback for leaflet resize call
    CanvasLayer.prototype.updateTree = function () {
        var bounds = this._map.getBounds();
        var nodes = this._nodes;
        var len = nodes.length;
        var visible = [];
        for (var i = 0; i < len; i++) {
            if (bounds.intersects(nodes[i]._rect)) {
                visible.push(nodes[i]);
            }
        }
        this._tree.clear();
        this._tree.insert(visible);
    };
    CanvasLayer.prototype.onRemove = function (map) {
        this._container.parentNode &&
            this._container.parentNode.removeChild(this._container);
        map.off({
            viewreset: this._reset,
            move: this._reposition,
            // 'mousedown': this.redraw,
            click: this._pick,
            mousedown: this._startDrag,
            mouseup: this._endDrag,
            mousemove: this._mouseMove,
            resize: this._resize,
            zoomstart: this._zoomStart,
            zoom: this._zoom,
            zoomend: this._zoomEnd
        }, this);
        return this;
    };
    // reset canvas layer positioning
    CanvasLayer.prototype._reset = function () {
        var size = this._map.getSize();
        this._canvas.width = size.x;
        this._canvas.height = size.y;
        this._quadCanvas.width = size.x;
        this._quadCanvas.height = size.y;
        this._drawCanvas.width = size.x;
        this._drawCanvas.height = size.y;
        // fix position
        var pos = L.DomUtil.getPosition(this._map.getPanes().mapPane);
        if (pos) {
            L.DomUtil.setPosition(this._canvas, new L.Point(-pos.x, -pos.y));
            L.DomUtil.setPosition(this._quadCanvas, new L.Point(-pos.x, -pos.y));
            L.DomUtil.setPosition(this._drawCanvas, new L.Point(-pos.x, -pos.y));
        }
        this._tree = new QuadTree_1.QuadTree({
            x: pos.x,
            y: pos.y,
            width: this._canvas.width,
            height: this._canvas.height
        }, 4, 4);
        /** set bounds for the stage */
        this._bounds = new createjs.Rectangle(pos.x, pos.x, this._quadCanvas.width, this._quadCanvas.height);
    };
    CanvasLayer.prototype.draw = function () {
        return this._reset();
    };
    CanvasLayer.prototype._disableZoom = function () {
        this._map.dragging.disable();
        this._map.touchZoom.disable();
        this._map.doubleClickZoom.disable();
        this._map.scrollWheelZoom.disable();
        this._map.boxZoom.disable();
        this._map.keyboard.disable();
    };
    CanvasLayer.prototype._enableZoom = function () {
        this._map.dragging.enable();
        this._map.touchZoom.enable();
        this._map.doubleClickZoom.enable();
        this._map.scrollWheelZoom.enable();
        this._map.boxZoom.enable();
        this._map.keyboard.enable();
    };
    CanvasLayer.prototype._startDrag = function (e) {
        var point = e.layerPoint;
        // if (this._map.dragging._draggable._newPos) {
        //   point = point.add(this._map.dragging._draggable._newPos)
        // }
        this._dragging = true;
        this._dragStartPoint = point;
        this._dragStartPointOriginal = point;
        if (this._tool === define.SELECT_TOOL_PAN) {
            this._map.dragging.enable();
            this._enableZoom();
        }
        else {
            this._map.dragging.disable();
            this._disableZoom();
        }
        if (this._tool === define.SELECT_TOOL_AREA) {
            // clear already selected nodes
            for (var i = 0; i < this._nodes.length; i++) {
                var node = this._nodes[i];
                node.setSelected(false);
            }
            this._selectedNodes = [];
            this._update();
        }
        if (this._dragging &&
            (this._drawingTool === define.DRAWING_TOOL_PENCIL ||
                this._drawingTool === define.DRAWING_TOOL_BRUSH)) {
            this._dragBuffer = [];
        }
    };
    CanvasLayer.prototype._endDrag = function (e) {
        var _this = this;
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        // const origin = this._map.getPixelOrigin()
        var startPoint = this._dragStartPointOriginal;
        var endPoint = this._dragStartPoint;
        if (this._map.dragging._draggable._newPos) {
            startPoint = startPoint.add(this._map.dragging._draggable._newPos);
            endPoint = endPoint.add(this._map.dragging._draggable._newPos);
        }
        if (this._dragging && this._tool === define.SELECT_TOOL_PICK) {
            var nodes = this._selectedNodes;
            var len = nodes.length;
            for (var i = 0; i < len; i++) {
                var node = nodes[i];
                node.onMoveEnd(e);
            }
        }
        /** PATH */
        if (this._dragging &&
            (this._drawingTool === define.DRAWING_TOOL_PENCIL ||
                this._drawingTool === define.DRAWING_TOOL_BRUSH)) {
            var latlngPath = this._dragBuffer.map(function (n) {
                return _this._map.layerPointToLatLng(n);
            });
            var marking = {
                type: 'PATH',
                path: latlngPath,
                status: 'PENDING',
                color: { stroke: this.getColor(), fill: this.getColor() }
            };
            this.addMarking(marking);
        }
        /** RECT */
        if (this._dragging && this._drawingTool === define.DRAWING_TOOL_RECTANGLE) {
            var bounds = new L.Bounds(startPoint, endPoint);
            if (!bounds.min || !bounds.max) {
                return;
            }
            var latlngBounds = new L.LatLngBounds(this._map.layerPointToLatLng(bounds.min), this._map.layerPointToLatLng(bounds.max));
            var marking = {
                type: 'RECTANGLE',
                bounds: {
                    nw: latlngBounds.getNorthWest(),
                    ne: latlngBounds.getNorthEast(),
                    sw: latlngBounds.getSouthWest(),
                    se: latlngBounds.getSouthEast()
                },
                status: 'PENDING',
                color: { stroke: this.getColor(), fill: 'rgba(0, 0, 0, 0)' }
            };
            this.addMarking(marking);
        }
        /** CLOUD */
        if (this._dragging && this._drawingTool === define.DRAWING_TOOL_CLOUD) {
            // calculate the distance the mouse travelled and scale the cloud according to that
            var bounds = new L.Bounds(startPoint, endPoint);
            if (!bounds.min || !bounds.max) {
                return;
            }
            var latlngBounds = new L.LatLngBounds(this._map.layerPointToLatLng(bounds.min), this._map.layerPointToLatLng(bounds.max));
            var marking = {
                type: 'CLOUD',
                bounds: {
                    nw: latlngBounds.getNorthWest(),
                    ne: latlngBounds.getNorthEast(),
                    sw: latlngBounds.getSouthWest(),
                    se: latlngBounds.getSouthEast()
                },
                status: 'PENDING',
                color: { stroke: this.getColor(), fill: 'rgba(0, 0, 0, 0)' },
                reverseX: startPoint.x > endPoint.x,
                reverseY: startPoint.y > endPoint.y
            };
            this.addMarking(marking);
        }
        /** CIRCLE */
        if (this._dragging && this._drawingTool === define.DRAWING_TOOL_CIRCLE) {
            // calculate the distance the mouse travelled and scale the cloud according to that
            var latlngBounds = new L.LatLngBounds(this._map.layerPointToLatLng(startPoint), this._map.layerPointToLatLng(endPoint));
            var marking = {
                type: 'CIRCLE',
                bounds: {
                    nw: latlngBounds.getNorthWest(),
                    ne: latlngBounds.getNorthEast(),
                    sw: latlngBounds.getSouthWest(),
                    se: latlngBounds.getSouthEast()
                },
                status: 'PENDING',
                color: { stroke: this.getColor(), fill: 'rgba(0, 0, 0, 0)' },
                reverseX: startPoint.x > endPoint.x,
                reverseY: startPoint.y > endPoint.y
            };
            this.addMarking(marking);
        }
        // clean up
        this._dragBuffer = [];
        this._dragStartPointOriginal = null;
        this._dragStartPoint = null;
        this._enableZoom();
        this._dragging = false;
        // render selection area
        if (this._tool === define.SELECT_TOOL_AREA) {
            this.renderSelection();
        }
        // clear draw context
        this._drawShape.graphics.clear();
        this._drawStage.clear();
        this._drawStage.update();
        this.updateTree();
    };
    CanvasLayer.prototype._mouseMove = function (e) {
        if (!this._dragging) {
            return;
        }
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        if (this._dragging && this._tool === define.SELECT_TOOL_PICK) {
            var graphics = this._shape.graphics;
            var map = this._map;
            var center = map.getCenter();
            var nodes = this._selectedNodes;
            var len = nodes.length;
            var dX = Math.round(e.layerPoint.x - this._dragStartPoint.x);
            var dY = Math.round(e.layerPoint.y - this._dragStartPoint.y);
            // Move selected nodes according to mouse movement
            for (var i = 0; i < len; i++) {
                nodes[i].onMove(e, new L.Point(dX, dY));
            }
        }
        else if (this._dragging &&
            this._tool === define.SELECT_TOOL_AREA &&
            this._dragStartPointOriginal) {
            var minX = Math.min(e.layerPoint.x, this._dragStartPointOriginal.x);
            var minY = Math.min(e.layerPoint.y, this._dragStartPointOriginal.y);
            var maxX = Math.max(e.layerPoint.x, this._dragStartPointOriginal.x);
            var maxY = Math.max(e.layerPoint.y, this._dragStartPointOriginal.y);
            var bounds = new L.Bounds(new L.Point(minX, minY), new L.Point(maxX, maxY));
            var nodes = this._nodes; // this._tree.retrieve({ x: minX, y: minY, )
            var picked = [];
            var len = nodes.length;
            var scale = this._map.options.crs
                ? this._map.options.crs.scale(this._map.getZoom())
                : 0;
            // pick new selected nodes
            for (var i = 0; i < len; i++) {
                var node = nodes[i];
                var boundingBox = new L.Bounds([
                    new L.Point(node.x, node.y),
                    new L.Point(node.x + node.width * (scale / node._scale), node.y + node.height * (scale / node._scale))
                ]);
                if (bounds.overlaps(boundingBox)) {
                    node.setSelected(true);
                    picked.push(node);
                }
                else {
                    node.setSelected(false);
                }
            }
            this._selectedNodes = picked;
        }
        else if (this._dragging &&
            (this._drawingTool === define.DRAWING_TOOL_PENCIL ||
                this._drawingTool === define.DRAWING_TOOL_BRUSH)) {
            var point = e.layerPoint;
            if (this._map.dragging._draggable._newPos) {
                point = point.add(this._map.dragging._draggable._newPos);
            }
            this._dragBuffer.push(point);
        }
        this._dragStartPoint = e.layerPoint;
        this._update();
    };
    CanvasLayer.prototype._pick = function (e) {
        if (this._tool !== define.SELECT_TOOL_PICK || this._dragging) {
            return;
        }
        var point = e.layerPoint;
        var selectedNodes = this._selectedNodes;
        var picked = [];
        if (this._map.dragging._draggable._newPos) {
            point = point.add(this._map.dragging._draggable._newPos);
        }
        // clear already selected nodes
        for (var i = 0; i < this._selectedNodes.length; i++) {
            var node = this._selectedNodes[i];
            node.setSelected(false);
        }
        this._selectedNodes = [];
        var x = point.x, y = point.y;
        var cursorBounds = new L.Bounds([
            new L.Point(x - 1, y - 1),
            new L.Point(x + 1, y + 1)
        ]); // TODO: SET CURSOR SIZE(1) AS DEFINITION
        var nodes = this._tree.retrieve(new QuadTree_1.BoundsNode({ x: x, y: y, width: 1, height: 1 }, 4, 4, 4));
        var len = nodes.length;
        // pick new selected nodes
        for (var i = 0; i < len; i++) {
            var node = nodes[i];
            var scale = this._map.options.crs
                ? this._map.options.crs.scale(this._map.getZoom()) /
                    node._scale
                : 0;
            var bounds = new L.Bounds([
                new L.Point(node.x, node.y),
                new L.Point(node.x + node.width * scale, node.y + node.height * scale)
            ]);
            // check if intersects with bounding box of the element
            if (cursorBounds.overlaps(bounds)) {
                // check if click intersects with the actual element
                var ctx = this.getContext();
                // get image data at mouse x,y pixel
                var imageData = ctx.getImageData(point.x, point.y, 1, 1);
                // const image = (point.x, point.y * node.width) * 4
                // if the mouse pixel exists, select and break
                // we scored big this time folks!
                if (imageData.data[3] > define.BG_TRANSPARENCY) {
                    // check that the picked color matches the color of the object
                    var pickedRGBA = 'rgba(' +
                        imageData.data[0] +
                        ',' +
                        imageData.data[1] +
                        ',' +
                        imageData.data[2] +
                        ',' +
                        imageData[3] +
                        ')';
                    node._onClick();
                    // }
                }
                break;
            }
        }
        this._selectedNodes = picked;
    };
    CanvasLayer.prototype._zoomStart = function (e) {
        var nodes = this._nodes;
        var len = nodes.length;
        for (var i = 0; i < len; i++) {
            var item = nodes[i];
            item.onScaleStart(e);
        }
        this._zooming = true;
        this._animating = true;
    };
    CanvasLayer.prototype._zoom = function (e) {
        var nodes = this._nodes;
        var len = nodes.length;
        for (var i = 0; i < len; i++) {
            var item = nodes[i];
            item.onScale(e);
        }
    };
    CanvasLayer.prototype._zoomEnd = function (e) {
        var nodes = this._nodes;
        var len = nodes.length;
        for (var i = 0; i < len; i++) {
            var item = nodes[i];
            item.onScaleEnd(e);
        }
        this.updateTree();
        this._zooming = false;
        this._animating = false;
    };
    CanvasLayer.prototype._resize = function (e) {
        // this._reset()
        this._animating = true;
        /*
            const map = this._map
        const nodes = this._nodes
        const len = nodes.length
    
        for (let i = 0; i < len; i++) {
          const item = nodes[i]
          item.onReposition(e)
        }
            */
        this._animating = false;
        // this.updateTree()
        // this.redraw()
    };
    CanvasLayer.prototype._reposition = function (e) {
        // no need to reposition as the ongoing zooming event will handle this
        if (this._zooming === true) {
            return;
        }
        this._animating = true;
        var map = this._map;
        var nodes = this._nodes;
        var len = nodes.length;
        for (var i = 0; i < len; i++) {
            var item = nodes[i];
            item.onReposition(e);
        }
        this._animating = false;
    };
    CanvasLayer.prototype._update = function () {
        var scale = this._map.options.crs
            ? this._map.options.crs.scale(this._map.getZoom())
            : 0;
        if (this._dragging === true &&
            this._dragStartPointOriginal &&
            this._dragStartPoint) {
            /** paint user interactions to draw layer if anything is going on */
            var startPoint = this._dragStartPointOriginal;
            var endPoint = this._dragStartPoint;
            if (this._map.dragging._draggable._newPos) {
                startPoint = startPoint.add(this._map.dragging._draggable._newPos);
                endPoint = endPoint.add(this._map.dragging._draggable._newPos);
            }
            if (!this._dragStartPoint) {
                return;
            }
            var diff = endPoint.subtract(startPoint);
            if (this._drawingTool === define.DRAWING_TOOL_PENCIL ||
                this._drawingTool === define.DRAWING_TOOL_BRUSH) {
                (0, Path_1.drawPath)(this._drawShape.graphics, this._dragBuffer, new L.Bounds(startPoint, endPoint), scale, { fill: this._color, stroke: this._color });
            }
            else if (this._drawingTool === define.DRAWING_TOOL_RECTANGLE) {
                (0, Rectangle_1.drawRectangle)(this._drawShape.graphics, startPoint.x, startPoint.y, diff.x, diff.y, new L.Bounds(startPoint, endPoint), scale, { fill: 'rgba(0, 0, 0, 0)', stroke: this._color });
            }
            else if (this._drawingTool === define.DRAWING_TOOL_CLOUD) {
                (0, Cloud_1.drawCloud)(this._drawShape.graphics, new L.Bounds(startPoint, endPoint), scale, startPoint.x > endPoint.x, startPoint.y > endPoint.y, { fill: 'rgba(0, 0, 0, 0)', stroke: this._color });
            }
            else if (this._drawingTool === define.DRAWING_TOOL_CIRCLE) {
                (0, Circle_1.drawCircle)(this._drawShape.graphics, startPoint.x, startPoint.y, new L.Bounds(startPoint, endPoint), scale, { fill: 'rgba(0, 0, 0, 0)', stroke: this._color });
            }
            this._drawStage.update();
        }
    };
    // force redraw, set direct to true if inside animation frame call
    CanvasLayer.prototype.redraw = function () {
        // update & render tree
        if (define.DEBUGGING) {
            this.renderQuad();
        }
        // render selection area
        if (this._tool === define.SELECT_TOOL_AREA &&
            this._dragStartPointOriginal &&
            this._dragStartPoint) {
            this.renderSelection();
        }
        this._stage.update();
        if (define.DEBUGGING) {
            this._quadStage.update();
        }
    };
    CanvasLayer.prototype._latLngToLayerPoint = function (latLng, zoom) {
        var point = this._map.project(latLng, zoom)._round();
        return point._subtract(this._map.getPixelOrigin());
    };
    CanvasLayer.prototype._createCanvas = function (options) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'absolute';
        canvas.style.top = '100';
        canvas.style.left = '100';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = '2';
        canvas.setAttribute('class', '');
        return canvas;
    };
    /** recursively draw node and it's children */
    CanvasLayer.prototype.drawNode = function (node) {
        var bounds = node._bounds;
        var graphics = this._shape.graphics;
        graphics.drawRect(abs(bounds.x) + 0.5, abs(bounds.y) + 0.5, bounds.width, bounds.height);
        var len = node.nodes.length;
        for (var i = 0; i < len; i++) {
            this.drawNode(node.nodes[i]);
        }
    };
    /** render selection box */
    CanvasLayer.prototype.renderSelection = function () {
        var graphics = this._shape.graphics;
        if (!this._dragStartPointOriginal) {
            return;
        }
        var startPoint = this._dragStartPointOriginal;
        var endPoint = this._dragStartPoint;
        (0, Rectangle_1.drawRectangle)(this._drawShape.graphics, abs(this._dragStartPointOriginal.x), abs(this._dragStartPointOriginal.y), this._dragStartPoint.x - this._dragStartPointOriginal.x, this._dragStartPoint.y - this._dragStartPointOriginal.y, new L.Bounds(startPoint, endPoint), 1, {
            stroke: 'rgba(0, 180, 0, 0.8',
            fill: 'rgba(0, 180, 0, 0.3)'
        });
    };
    /** render quad */
    CanvasLayer.prototype.renderQuad = function () {
        var graphics = this._shape.graphics;
        graphics.clear();
        graphics.setStrokeStyle(1);
        graphics.beginStroke('#000000');
        this.drawNode(this._tree.root);
    };
    CanvasLayer.prototype.render = function () {
        return;
    };
    return CanvasLayer;
}(L.Layer));
var clickHandler = function (f) { return function (e) {
    var state = f();
    if (state.onClick) {
        state.onClick(e, state.map);
    }
}; };
var enhanceTileLayer = recompose.compose(recompose.withState('element', 'setElement', null), recompose.lifecycle({
    componentDidMount: function () {
        var _this = this;
        var map = L.map(this.props.id, {
            center: [this.props.point.x, this.props.point.y],
            zoom: 1,
            zoomDelta: 0.25,
            zoomSnap: 0.5,
            wheelPxPerZoomLevel: 50,
            maxZoom: 14,
            crs: L.CRS.Simple,
            attributionControl: false,
            zoomControl: false,
            inertia: false,
            touchZoom: true
        });
        this.props.setMap(map);
        map.on('click', clickHandler(function () { return _this.props; }));
    },
    componentWillUnmount: function () {
        var _this = this;
        if (!this.props.map) {
            return;
        }
        this.props.map.off('click', clickHandler(function () { return _this.props; }));
    },
    componentWillReceiveProps: function (nextProps) {
        if ((!this.props.element && nextProps.element && nextProps.map) ||
            (nextProps.image !== this.props.image &&
                nextProps.element &&
                nextProps.map)) {
            if (nextProps.image) {
                // remove olf image layers from the map
                // @ts-ignore
                nextProps.map.eachLayer(function (l) { return l._image && l.remove(); });
                var imageBounds_1 = [
                    [0, 0],
                    [100, 100]
                ];
                nextProps.image.forEach(function (i) {
                    L.imageOverlay(i, imageBounds_1).addTo(nextProps.map);
                });
                nextProps.map.fitBounds(imageBounds_1);
                var canvasLayer = new CanvasLayer();
                canvasLayer.addTo(nextProps.map);
                canvasLayer.addMarking = nextProps.addMarking;
                canvasLayer.setTool(nextProps.tool);
                nextProps.setCanvas(canvasLayer);
                nextProps.onLoaded();
            }
        }
        // New markings added
        if (this.props.markings !== nextProps.markings) {
            // Create instances
            var canvasLayer = nextProps.canvas;
            var added = nextProps.markings;
            if (!canvasLayer) {
                return;
            }
            canvasLayer.clear();
            var map = nextProps.map;
            var crs = map.options.crs;
            var zoom = map.getZoom();
            var scale = crs.scale(zoom);
            var origin = map.getPixelOrigin();
            var _loop_1 = function (i) {
                var x = added[i];
                if (x.type === 'TEXT') {
                    // @ts-ignore
                    var t = new Text_1.default(map, x.point, x.text, '"Roboto", sans-serif', 12, x.color, 400, 'left', 'middle');
                    canvasLayer.insert(t);
                }
                else if (x.type === 'TASK') {
                    var name = x.text;
                    var splitted = name.trim().split(' ');
                    var text = (splitted.length > 1
                        ? [
                            splitted[0].substring(0, 1),
                            splitted[1].substring(0, 1)
                        ].join('')
                        : name.substring(0, 1)).toUpperCase();
                    var coordinate = x.point;
                    var point = latlngToPoint(map, origin, coordinate, map.getZoom());
                    var startPoint = point;
                    var endPoint = point.add(new L.Point(32 * scale, 32 * scale));
                    var startCoord = map.layerPointToLatLng(startPoint);
                    var endCoord = map.layerPointToLatLng(endPoint);
                    var bounds = new L.LatLngBounds([startCoord, endCoord]);
                    var color = { fill: '#fff', stroke: '#fff' };
                    // @ts-ignore
                    var c = new Circle_1.default(map, bounds, false, false, {
                        fill: '#0084f8',
                        stroke: '#e3e5e6'
                    });
                    // @ts-ignore
                    var t = new Text_1.default(map, coordinate, text, '"Roboto", sans-serif', 16, color, 900, 'center', 'middle');
                    canvasLayer.insert(c);
                    canvasLayer.insert(t);
                }
                else if (x.type === 'HYPERLINK') {
                    var coordinate = x.point;
                    var point = latlngToPoint(map, origin, coordinate, map.getZoom());
                    var startPoint = point;
                    var endPoint = point.add(new L.Point(32 * scale, 32 * scale));
                    var startCoord = map.layerPointToLatLng(startPoint);
                    var endCoord = map.layerPointToLatLng(endPoint);
                    var bounds = new L.LatLngBounds([startCoord, endCoord]);
                    var color = { fill: '#fff', stroke: '#fff' };
                    var onClick = function () { return window.open(x.link, '_blank'); };
                    // @ts-ignore
                    var c = new Circle_1.default(map, bounds, false, false, { fill: '#0084f8', stroke: '#e3e5e6' }, onClick);
                    // @ts-ignore
                    var t = new Text_1.default(map, coordinate, '\uF0C1', '"Font Awesome 5 Free"', 14, color, 900, 'center', 'middle');
                    canvasLayer.insert(c);
                    canvasLayer.insert(t);
                }
                else if (x.type === 'RECTANGLE') {
                    var bounds = new L.LatLngBounds(new L.LatLng(x.bounds.nw.lat, x.bounds.nw.lng), new L.LatLng(x.bounds.se.lat, x.bounds.se.lng));
                    // @ts-ignore
                    var r = new Rectangle_1.default(map, bounds, x.color);
                    canvasLayer.insert(r);
                }
                else if (x.type === 'CIRCLE') {
                    var bounds = new L.LatLngBounds(new L.LatLng(x.bounds.nw.lat, x.bounds.nw.lng), new L.LatLng(x.bounds.se.lat, x.bounds.se.lng));
                    // @ts-ignore
                    var c = new Circle_1.default(map, bounds, x.reverseX || false, x.reverseY || false, x.color);
                    canvasLayer.insert(c);
                }
                else if (x.type === 'CLOUD') {
                    var bounds = new L.LatLngBounds(new L.LatLng(x.bounds.nw.lat, x.bounds.nw.lng), new L.LatLng(x.bounds.se.lat, x.bounds.se.lng));
                    // @ts-ignore
                    var c = new Cloud_1.default(map, bounds, x.reverseX || false, x.reverseY || false, x.color);
                    canvasLayer.insert(c);
                }
                else if (x.type === 'PATH') {
                    if (x.path && x.path.length > 0) {
                        // @ts-ignore
                        var p = new Path_1.default(map, x.path, x.color);
                        canvasLayer.insert(p);
                    }
                }
            };
            for (var i = 0; i < added.length; i++) {
                _loop_1(i);
            }
        }
        if (nextProps.tool !== this.props.tool) {
            nextProps.canvas && nextProps.canvas.setTool(nextProps.tool);
        }
        if (nextProps.drawingTool !== this.props.drawingTool) {
            nextProps.canvas &&
                nextProps.canvas.setDrawingTool(nextProps.drawingTool);
        }
        if (nextProps.color !== this.props.color) {
            nextProps.canvas && nextProps.canvas.setColor(nextProps.color);
        }
    }
}));
exports.TileLayer = enhanceTileLayer(function (props) { return (React.createElement("div", { id: props.id, ref: props.setElement, style: { width: '100%', zIndex: 1, overflow: 'hidden' } })); });
var enhanceTaskModal = recompose.compose(recompose.withState('name', 'setName', undefined), recompose.pure);
exports.TaskModal = enhanceTaskModal(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'sok-drawing-tool-modal' },
    React.createElement("div", { className: 'container' },
        React.createElement("div", { className: 'content' },
            React.createElement(sok_ui_1.Input, { type: 'text', label: 'Enter name', onChange: function (e) { return props.setName(e.target.value); } })),
        React.createElement("div", { className: 'footer' },
            React.createElement(sok_ui_1.Button, { text: 'Submit', color: 'base-green', onClick: function () {
                    props.onSubmit(props.name);
                } }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: props.onRequestClose }))))); });
var enhanceTextModal = recompose.compose(recompose.withState('name', 'setName', undefined), recompose.pure);
exports.TextModal = enhanceTextModal(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'sok-drawing-tool-modal' },
    React.createElement("div", { className: 'container' },
        React.createElement("div", { className: 'content' },
            React.createElement(sok_ui_1.Input, { type: 'text', label: 'Enter text', onChange: function (e) { return props.setName(e.target.value); } })),
        React.createElement("div", { className: 'footer' },
            React.createElement(sok_ui_1.Button, { text: 'Submit', color: 'base-green', onClick: function () {
                    props.onSubmit(props.name);
                } }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: props.onRequestClose }))))); });
var enhanceHyperlinkModal = recompose.compose(recompose.withState('url', 'setUrl', undefined), recompose.pure);
exports.HyperlinkModal = enhanceHyperlinkModal(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'sok-drawing-tool-modal' },
    React.createElement("div", { className: 'container' },
        React.createElement("div", { className: 'content' },
            React.createElement(sok_ui_1.Input, { type: 'text', label: 'Enter url', onChange: function (e) { return props.setUrl(e.target.value); } })),
        React.createElement("div", { className: 'footer' },
            React.createElement(sok_ui_1.Button, { text: 'Submit', color: 'base-green', onClick: function () {
                    props.onSubmit(props.url);
                } }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: props.onRequestClose }))))); });
var DrawingIcon = function (props) { return (React.createElement("span", { style: props.style, className: props.active ? 'active' : '', onClick: props.onClick }, props.children)); };
exports.DrawingIcon = DrawingIcon;
var DrawingPanel = function (props) { return React.createElement("div", { className: 'sok-drawing-tool-panel' }, props.children); };
exports.DrawingPanel = DrawingPanel;
var mouseMoveHandler = function (container, cursor) { return function (e) {
    var offset = container.getBoundingClientRect();
    var x = e.pageX - offset.left - window.pageXOffset;
    var y = e.pageY - offset.top - window.pageYOffset;
    cursor.style.left = x - define.CURSOR_OFFSET + 'px';
    cursor.style.top = y - define.CURSOR_OFFSET + 'px';
}; };
var enhanceCursor = recompose.compose(recompose.withState('element', 'setElement', undefined), recompose.lifecycle({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.element !== nextProps.element) {
            this.props.container.addEventListener('mousemove', mouseMoveHandler(nextProps.container, nextProps.element));
        }
    },
    componentWillUnmount: function () {
        this.props.container.removeEventListener('mousemove', mouseMoveHandler(this.props.container, this.props.element));
    }
}), recompose.pure);
exports.Cursor = enhanceCursor(function (props) { return (React.createElement("div", { style: { background: props.color }, ref: function (e) { return props.setElement(e); }, className: 'sok-drawing-tool-cursor' })); });
var enhance2 = recompose.compose(recompose.withState('point', 'setPoint', { x: 50, y: 50 }), recompose.withState('clickCoordinate', 'setClickCoordinate', null), recompose.withState('element', 'setElement', null), recompose.withState('dragging', 'setDragging', false), recompose.withState('tool', 'setTool', define.SELECT_TOOL_PAN), recompose.withState('drawingTool', 'setDrawingTool', define.DRAWING_TOOL_NONE), recompose.withState('textInputActive', 'setTextInputActive', false), recompose.withState('map', 'setMap', null), recompose.withState('canvas', 'setCanvas', null), recompose.withState('value', 'setValue', null), recompose.withState('color', 'setColor', {
    fill: define.DEFAULT_COLOR,
    stroke: define.DEFAULT_COLOR
}), recompose.pure);
exports.DrawingArea = enhance2(function (props) { return (React.createElement("div", { className: classNames('sok-drawing-tool-area', props.drawingTool !== define.DRAWING_TOOL_NONE &&
        props.tool !== define.SELECT_TOOL_PAN
        ? 'active'
        : ''), ref: props.setElement },
    React.createElement("div", { className: 'sok-panel-container' },
        React.createElement(exports.DrawingPanel, null,
            React.createElement(exports.DrawingIcon, { active: false, onClick: function () {
                    props.map.zoomIn(1);
                } },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/tools/zoomIn')) },
                    React.createElement(Icon_1.Icon, { className: 'fa-plus' }))),
            React.createElement(exports.DrawingIcon, { active: false, onClick: function () {
                    props.map.zoomOut(1);
                } },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/tools/zoomOut')) },
                    React.createElement(Icon_1.Icon, { className: 'fa-minus' }))),
            React.createElement(exports.DrawingIcon, { active: props.tool === define.SELECT_TOOL_PAN, onClick: function () {
                    props.setDrawingTool(define.DRAWING_TOOL_NONE);
                    props.setTool(define.SELECT_TOOL_PAN);
                } },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/tools/center')) },
                    React.createElement(Icon_1.Icon, { className: 'fa-arrows-alt' }))))),
    props.drawingTool !== define.DRAWING_TOOL_NONE &&
        props.tool === define.SELECT_TOOL_NONE ? (React.createElement(exports.Cursor, { color: props.color.fill, container: props.element })) : null,
    React.createElement(exports.TaskModal, { isOpen: props.textInputActive &&
            props.clickCoordinate &&
            props.drawingTool === define.DRAWING_TOOL_MARKER, onRequestClose: function () {
            props.setTextInputActive(false);
            props.setClickCoordinate(null);
        }, onSubmit: function (name) {
            var clickCoordinate = props.clickCoordinate;
            var marking = {
                type: 'TASK',
                point: clickCoordinate,
                status: 'PENDING',
                text: name
            };
            props.addMarking(marking);
            props.setTextInputActive(false);
            props.setClickCoordinate(null);
        } }),
    React.createElement(exports.TextModal, { isOpen: props.textInputActive &&
            props.clickCoordinate &&
            props.drawingTool === define.DRAWING_TOOL_TEXT, onRequestClose: function () {
            props.setTextInputActive(false);
            props.setClickCoordinate(null);
        }, onSubmit: function (text) {
            var map = props.map, color = props.color, clickCoordinate = props.clickCoordinate;
            var coordinate = clickCoordinate;
            var marking = {
                type: 'TEXT',
                point: coordinate,
                status: 'PENDING',
                text: text,
                color: color
            };
            props.addMarking(marking);
            props.setTextInputActive(false);
            props.setClickCoordinate(null);
        } }),
    React.createElement(sok_ui_1.Modal, { isOpen: props.textInputActive &&
            props.clickCoordinate &&
            props.drawingTool === define.DRAWING_TOOL_PHOTO, className: 'sok-drawing-tool-modal' },
        React.createElement("div", { className: 'container' },
            React.createElement("div", { className: 'content' }),
            React.createElement("div", { className: 'footer' },
                React.createElement(sok_ui_1.Button, { text: 'Submit', color: 'base-green', onClick: function () {
                        props.setTextInputActive(false);
                        props.setClickCoordinate(null);
                    } }),
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: function () {
                        props.setTextInputActive(false);
                        props.setClickCoordinate(null);
                    } })))),
    React.createElement(exports.HyperlinkModal, { isOpen: props.textInputActive &&
            props.clickCoordinate &&
            props.drawingTool === define.DRAWING_TOOL_LINK, onRequestClose: function () {
            props.setTextInputActive(false);
            props.setClickCoordinate(null);
        }, onSubmit: function (url) {
            var map = props.map, clickCoordinate = props.clickCoordinate;
            var color = { fill: '#fff', stroke: '#fff' };
            var marking = {
                type: 'HYPERLINK',
                point: clickCoordinate,
                status: 'PENDING',
                link: url
            };
            props.addMarking(marking);
            props.setTextInputActive(false);
            props.setClickCoordinate(null);
        } }),
    React.createElement(exports.TileLayer, { id: props.id, tool: props.tool, color: props.color.fill, drawingTool: props.drawingTool, point: props.point, map: props.map, setPoint: function (p) { return props.setPoint(p); }, setMap: props.setMap, setCanvas: props.setCanvas, canvas: props.canvas, image: props.image, markings: props.markings, addMarking: props.addMarking, onLoaded: props.onLoaded, onClick: function (e, map) {
            if ((props.tool !== define.SELECT_TOOL_NONE &&
                props.tool !== define.SELECT_TOOL_PAN) ||
                props.drawingTool !== define.DRAWING_TOOL_NONE) {
                map.doubleClickZoom.disable();
            }
            switch (props.drawingTool) {
                case define.DRAWING_TOOL_MARKER:
                case define.DRAWING_TOOL_TEXT:
                case define.DRAWING_TOOL_LINK:
                case define.DRAWING_TOOL_PHOTO:
                    props.setClickCoordinate(e.latlng);
                    props.setTextInputActive(true);
                    break;
            }
        } }))); });
